import React, { useCallback, useState } from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { useDispatch } from 'react-redux';
import {
  createEquipmentTypeAction,
  deleteEquipmentTypeAction,
  editEquipmentTypeAction
} from 'src/store/actions/catalogActions';
import { useTranslation } from 'react-i18next';
import Toolbar from '../Toolbar';
import EquipmentTypeList from './EquipmentTypeList';
import EquipmentTypeForm from './EquipmentTypeForm';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const EquipmentTypesListView = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleClose = useCallback(() => {
    setOpen(false);
    setData(null);
  }, [setOpen, setData]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleOpenEdit = useCallback(
    values => {
      setOpen(true);
      setData(values);
    },
    [setOpen, setData]
  );

  const handleCreate = useCallback(
    values => {
      delete values.serviceId;
      dispatch(createEquipmentTypeAction(values));
      handleClose();
    },
    [handleClose, dispatch]
  );

  const handleEdit = useCallback(
    values => {
      dispatch(editEquipmentTypeAction(values));
      handleClose();
    },
    [handleClose, dispatch]
  );

  const handleDelete = useCallback(
    name => {
      dispatch(deleteEquipmentTypeAction(name));
      handleClose();
    },
    [handleClose, dispatch]
  );

  return (
    <Page
      className={classes.root}
      title={t('NAVIGATION.CATALOG_LIST.EQUIPMENT_TYPES')}
    >
      <Container maxWidth={false}>
        <Toolbar
          catalogLabel={t('NAVIGATION.CATALOG_LIST.EQUIPMENT_TYPES')}
          handleOpen={handleOpen}
        />
        <Box mt={3}>
          <EquipmentTypeList
            handleOpenEdit={handleOpenEdit}
            handleDelete={handleDelete}
          />
        </Box>
      </Container>
      <EquipmentTypeForm
        open={open}
        data={data}
        handleClose={handleClose}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
      />
    </Page>
  );
};

export default EquipmentTypesListView;
